import { trpc } from '@tencent/tpro_rmonitor_metrics_server_overview';
import AbstractHttpClient from '@/infrastructure/axios/request';
import { TrpcService } from '@/service/trpc';
import { WithTypeCast } from '@raft/utils';

export type IGetSDKVersionUpgradeTipReq = WithTypeCast<trpc.rmonitor.metrics_server.IGetSDKVersionUpgradeTipReq>;
export type IGetSDKVersionUpgradeTipRsp = WithTypeCast<trpc.rmonitor.metrics_server.IGetSDKVersionUpgradeTipRsp>;
// eslint-disable-next-line max-len
export type IGetSDKVersionUpgradeTipForProReq = WithTypeCast<trpc.rmonitor.metrics_server.IGetSDKVersionUpgradeTipForProReq>;
// eslint-disable-next-line max-len
export type IGetSDKVersionUpgradeTipForProRsp = WithTypeCast<trpc.rmonitor.metrics_server.IGetSDKVersionUpgradeTipForProRsp>;


export class OverviewService extends AbstractHttpClient {
  constructor() {
    super({
      serviceName: TrpcService.OverviewService,
    });
  }

  /**
   * 判断产品是否需要升级SDK版本
   * @param req
   */
  public async getSDKVersionUpgradeTip(req: IGetSDKVersionUpgradeTipReq): Promise<IGetSDKVersionUpgradeTipRsp> {
    try {
      const res = await this.trpcPost<IGetSDKVersionUpgradeTipRsp>('GetSDKVersionUpgradeTip', req);
      return res;
    } catch (e) {
      console.log('GetSDKVersionUpgradeTip', e);
      return {};
    }
  }
  // eslint-disable-next-line max-len
  public async getSDKVersionUpgradeTipForPro(req: IGetSDKVersionUpgradeTipForProReq): Promise<IGetSDKVersionUpgradeTipForProRsp> {
    try {
      const res = await this.trpcPost<IGetSDKVersionUpgradeTipRsp>('GetSDKVersionUpgradeTipForPro', req);
      return res;
    } catch (e) {
      console.log('GetSDKVersionUpgradeTipForPro', e);
      return {};
    }
  }
}

export const overviewService = new OverviewService();
